// removed by extract-text-webpack-plugin
module.exports = {"button":"DLPsFUj","button__isPrimary":"_17j3bzo","button__isSecondary":"_3esxOje","button__isTertiary":"_3XydiG-","button__hasInvertedSize":"_1RgKswx","content":"_2nuEW0_","content__isHidden":"ROe61ki","spinner":"_1FkCi2I"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Button/Button.css
// module id = ./template/components/Button/Button.css
// module chunks = client.sitechrome